import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import App from './App';
import { loadCarList, reCAPTCHA_SITE_KEY } from '../api';

export default class Root extends Component {
  componentWillMount() {
    loadCarList(this.props.store.dispatch);
  }

  componentDidMount() {
    $('body').append(`
      <script src="//www.google.com/recaptcha/api.js?render=${reCAPTCHA_SITE_KEY}"></script>
    `);
  }

  render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Root.js